// extracted by mini-css-extract-plugin
module.exports = {"bodyTemplate":"GymChainScheduleListStyle_bodyTemplate__3TNry"};